module.exports = __webpack_public_path__ + "img/8.8cb7a1bc.png";